import { api_POST_Unauthorize } from "api/axios.js";

const usuario_api =
{
    authenticate: function(json_submit){
        const promise = new Promise((resolve, reject) => { 
            api_POST_Unauthorize(`usuario/authenticate`, json_submit).then(result => {
                resolve(result)
            });
        });

        return promise;
    }

}

export default usuario_api
